
import { Vue, Component } from 'vue-property-decorator';
import { getDetail } from '../api';
@Component
export default class Detail extends Vue {
  id: any = '';
  item: any = {};
  async mounted() {
    this.id = this.$route.query.id;
    const res: any = await getDetail(this.id);
    this.item = res.data;
  }
  onJumpToOutside() {
        location.href = 'https://activity.cqcb.com/shangyou_activity/2022h1/2022-lianghui-h5/home';
  }
}
